export const CAPFindingLabelDefaultValues = {
  CAP_FINDING_LABEL_NOT_AVAILABLE: 'N/A'
};
